// extracted by mini-css-extract-plugin
export default {"root":"IconInfo_root__gKKaP","small":"IconInfo_small__HhDGj","medium":"IconInfo_medium__8RqgH","large":"IconInfo_large__nlgxD"};